import { render, staticRenderFns } from "./carryover-table.vue?vue&type=template&id=174df984"
import script from "./carryover-table.vue?vue&type=script&lang=js"
export * from "./carryover-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports